module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"code":{"invalidCode":"Invalid code","resendCodeIn":"Resend code in"}}}')
  delete Component.options._Ctor
}
